const defaultModalOverrides = "dibd1iddsvw";

export { defaultModalOverrides };
import "./_hook.manager.style.linaria.module.css";
//# sourceMappingURL=_hook.manager.style.js.map
